import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { UserSummary } from '@charbuilder/shared';

interface AuthState {
  token: string | null;
  user: UserSummary | null;
  setAuth: (token: string, user: UserSummary) => void;
  logout: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      token: null,
      user: null,
      setAuth: (token, user) => set({ token, user }),
      logout: () => set({ token: null, user: null }),
    }),
    { name: 'charbuilder-auth' },
  ),
);
